import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import Slider from "react-slick";
import AdminNav from './AdminNav';
import config from '../../../function/config';
import Footer from '../../Footer';


export default function RegisterAdmin() {

  
const [isScrolled, setIsScrolled] = useState(false);
 useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      
  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
      
        
        const navigate = useNavigate()
        
          

          const [formType, setFormType] = useState("sale"); // Default to "sale"
          const [loading,setLoading] = useState(false)
          const[Title,setTitle] = useState('')
          const[vesselType,setvesselType] = useState('')
          const[ShortDescription,setShortDescription] = useState('')
          const[Flag,setFlag] = useState('')
          const[YearBuilt,setYearBuilt] = useState('')
          const[Capacity,setCapacity] = useState('')
          const[LOA,setLOA] = useState('')
          const[Class,setClass] = useState('')
          const[GRTNRT,setGRTNRT] = useState('')
          const[Teu,setTeu] = useState('')
          const[Price,setPrice] = useState('')
          const[MainEngine,setMainEngine] = useState('')
          const[DWT,setDWT] = useState('')

          const[Email,setEmail] = useState('')
          const[MobileNO,setMobileNO] = useState('')
          const[BriefDescription,setBriefDescription] = useState('')
          const [images, setImages] = useState([]);
          const [ThumbnailImage, setThumbnailImage] = useState("");
          const [Image,setImage] = useState('')
          const [Nationality,setNationality] = useState('')
          const [BuyAsScrap,setBuyAsScrap] = useState('')
          const [From,setFrom] = useState('')
          const [To,setTo] = useState('')
          const [InspectionCountry,setInspectionCountry] = useState('')

          const [Category,setCategory] = useState('')
          const [Subject,setSubject] = useState('')

          const {id} = useParams()
          const[input,setInput] = useState('')
          

          const [count,setCount] = useState(0)


         const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
         
          
          
      
        const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
    

  
    // carousel customer
    const NextArrow = ({ onClick }) => (
      <button
        onClick={onClick}
        className="absolute  top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
      >
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    );
  
    const PrevArrow = ({ onClick }) => (
      <button
        onClick={onClick}
        className="absolute z-10  top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>
    );
  
  
    // carousel customer
    const NextArrowShip = ({ onClick }) => (
      <button
        onClick={onClick}
        className="absolute right-6 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
      >
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    );
  
    const PrevArrowShip = ({ onClick }) => (
      <button
        onClick={onClick}
        className="absolute z-10 left-4 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>
    );
  
    const settings = {
      dots: true,
      infinite: true,
      speed: 900,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      responsive: [
        {
          breakpoint: 1024, // From 1024px, show 3 slides
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 717, // From 717px, show 2 slides
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480, // From 480px, show 1 slide
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };
  
    const [currentSlideShip, setCurrentSlideShip] = useState(0);
    const [isLastSlide, setIsLastSlide] = useState(false); // Track if it's the last slide
    const ShipsliderRef = useRef(null);
     const [allShips, setallShips] = useState([]);
      const [allShipsReg, setallShipsReg] = useState([]);
    
     

  // Fetch Admin Ships
useEffect(() => {
  async function fetchdata() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res1.data.status === 200) {
        // Sort using created_at (not date_added)
        const sortedData = res1.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); 
        setallShips(sortedData.reverse());
        setCount(id);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [config.base_url, count]);


// Fetch Customer Registered Ships
useEffect(() => {
  async function fetchdata() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res1.data.status === 200) {
        // Sort using created_at (not date_added)
        const sortedData = res1.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); 
        setallShipsReg(sortedData.reverse());
        setCount(id);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [config.base_url, count]);


const [allImages,setallImages] = useState([])
  
  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :",res3);
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url,input,count]);

  // Add an identifier to distinguish Admin Ships and Customer Ships
const filteredAllShipsReg = allShipsReg
.filter((ship) => ship.is_allow)
.map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale

const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship

// Merge and sort ships by created_at (latest first)
const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
(a, b) => new Date(b.created_at) - new Date(a.created_at)
);


const [allImagesReg,setAllImagesReg] = useState([])
    
      useEffect(() => {
        async function fetchdata() {
          try {
            const res3 = await axios.get(
              `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              }
            );
            if (res3.data.status === 200) {
              console.log("Images :",res3);
              setAllImagesReg(res3.data.data);
            } else {
              console.log("error");
            }
          } catch (error) {
            console.log(error);
          }
        }
        fetchdata();
      }, [config.base_url,input,count]);


    
  const ship = {
    infinite: allShips.length > 1, // Enable infinite scroll only if there are more than 1 cards
    speed: 800,
    slidesToShow: Math.min(4, allShips.length), // Show fewer slides if there are not enough cards
    slidesToScroll: 1,
    spaceBetween: 5,
    autoplay: true,
    arrows: true,
    dots: false, // Show dots only if there is more than 1 card
    focusOnSelect: true,
    beforeChange: (current, next) => {
      setCurrentSlideShip(next);
    },
    nextArrow: <NextArrowShip />,
    prevArrow: <PrevArrowShip />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: Math.min(3, allShips.length),
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, allShips.length),
        },
      },
      {
        breakpoint: 1143,
        settings: {
          slidesToShow: Math.min(3, allShips.length),
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: Math.min(2, allShips.length),
        },
      },
      {
        breakpoint: 654,
        settings: {
          slidesToShow: Math.min(1,allShips.length),
        },
      },
    ],
    afterChange: (index) => {
      setCurrentSlideShip(index);
      if (index === allShips.length - 1) {
        setIsLastSlide(true);
      } else {
        setIsLastSlide(false);
      }
    },
  };
  
        
  return (
    <div className='bg-gradient-to-r from-[#2e5775] to-[#326e99] '>

        <AdminNav/>

        <section className='mt-14 mb-14 '>
          <h1 className='text-center text-white text-3xl mb-5 font-bold'>Registration Forms</h1>
        <div className="py-10 mt-14 px-[50px] xl:px-[10px] xm:px-[10px] 3xl:w-[100%] w-[80%] lg:w-[90%] m-auto border rounded border-white">
      {/* Links for selecting form type */}
      <div className="flex justify-center gap-8 xl:gap-5 L:flex-wrap lg:gap-5 items-center">
        <Link
          to={'/regShipforsaleadmin'}
          className={`
            bg-white xl:text-sm hover:bg-gray-200 shadow-xl text-[#2e5775] font-semibold
           rounded p-3 w-[100%] text-center`}
        >
          Register Ship For Sale
        </Link>
        <Link
           to={'/regShipforcharteradmin'}
           className={`
             bg-white xl:text-sm hover:bg-gray-200 shadow-xl text-[#2e5775] font-semibold
            rounded p-3 w-[100%]  text-center`}
        >
          Register Ship For Charter
        </Link>
        <Link
           to={'/reglogisticadmin'}
           className={`
             bg-white xl:text-sm hover:bg-gray-200 shadow-xl text-[#2e5775] font-semibold
            rounded p-3 w-[100%]  text-center`}
        >
          Register Logistics
        </Link>
        <Link
           to={'/regsupplyeqadmin'}
           className={`
             bg-white xl:text-sm hover:bg-gray-200 shadow-xl text-[#2e5775] font-semibold
            rounded p-3 w-[100%]  text-center`}
        >
          Register Supply Equipments
        </Link>
        
      </div>

       
      
    </div>
        
        <div className="cards-main mt-5 relative testimonial-carousel">
              <div className="testimonial-slide mt-10 py-5 relative">
              <Slider ref={ShipsliderRef} {...ship}>
  {sortedData.map((card, index) => (
    <div key={index} className="py-[20px] relative">
      <div 
        className="w-[280px] h-[350px] shadow-lg bg-gray-100 overflow-hidden transition-all rounded-lg border border-white     m-auto relative"
        
      >
        {/* Show "Out of Stock" watermark if is_status is false */}
        {card.is_status && (
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center">
            <span className="text-red-600 text-3xl font-bold rotate-[-20deg]">Out of Stock</span>
          </div>
        )}

        {/* <div>
          <img
          onClick={() => {
            if (card.isFromReg) {
              navigate(`/singleShipReg/${card.id}`); // Navigate to customer ship details
            } else {
              navigate(`/singleShiphome/${card.id}`); // Navigate to admin ship details
            }
          }}
            className="w-[280px] cursor-pointer rounded-t-lg h-[200px]"
            src={
              card.image || 
              allImages.find((img) => img.ship === card.id && img.thumbnail_image)?.thumbnail_image || 
              "fallback-image-url"
            }
            alt={card.title}
          />
        </div> */}
<div>
  {(() => {
    let imageUrl = null;

    // Get images based on source
    const images = card.isFromReg
      ? allImagesReg.filter((img) => img.ships === card.id)
      : allImages.filter((img) => img.ship === card.id);

    imageUrl = images[0]?.image; // Always use first main image

    if (!imageUrl) return null;

    const route = card.isFromReg
      ? `/singleShipReg/${card.id}`
      : `/singleShiphome/${card.id}`;

    return (
      <img
        onClick={() => navigate(route)}
        src={imageUrl}
        className="w-full rounded-t-lg cursor-pointer h-[200px]"
        alt="Ship"
      />
    );
  })()}
</div>




        <div className="px-2 py-3 mt-2">
          <h1 className="font-bold">{card.title || card.short_description}</h1>
        </div>

        <div className="px-2 py-3 flex gap-3 absolute bottom-0">
          <button
            onClick={() => {
              if (card.isFromReg) {
                navigate(`/singleShipReg/${card.id}`);
              } else {
                navigate(`/singleShiphome/${card.id}`);
              }
            }}
            className="bg-[#123d5f] hover:bg-[#212f3aed] text-white rounded-md px-3 py-2 shadow-lg hover:shadow-xl transition"
          >
            View More
          </button>
          <Link
  to={`https://wa.me/971503505898?text=${encodeURIComponent(
    `Hello MARINIZ, I would like to inquire about this ship. ID: ${card.id}, Ship Name: ${card.title}`
  )}`}
  className="bg-gray-50 border border-[#a1ccec] hover:bg-green-500 hover:text-white rounded-md px-3 py-2 shadow-lg hover:shadow-xl transition"
>
  Enquiry Now
</Link>
        </div>
      </div>
    </div>
  ))}
</Slider>

              </div>

              {/* Show Explore More button after the last slide */}

              <div className="absolute mb-14  left-1/2 transform -translate-x-1/2">
                <button
                  onClick={() => navigate("/shipforsale")}
                  className="bg-[#123d5f] text-white rounded-full px-4 py-2 hover:bg-[#0d2437] transition"
                >
                  Explore More
                </button>
              </div>
            </div>

        
        </section>
    

    
    {/* Go to Top Button */}
    {isScrolled && (
  <div
    className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
  >
    <div
      className="back-to-top px-4 hover:bg-[#615d91]"
      onClick={scrollToTop}
    >
      <i className="fa-solid fa-arrow-up text-2xl"></i>
    </div>
  </div>
)}
     
    <Footer/>
      
    </div>
  )
}
